import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE;

const UserPreview = () => {
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTopUsers = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/preview/user-preview`);
        setUsers(res.data);
      } catch (err) {
        console.error("Failed to fetch top users", err);
      }
    };
    fetchTopUsers();
  }, []);

  const handleLoginRedirect = () => {
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-100 via-white to-indigo-200 px-4 py-6">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-2xl font-bold mb-6 text-indigo-700">Discover Language Learners</h1>

        <div className="space-y-4">
          {users.map((u) => (
            <div
              key={u._id}
              className="w-full min-h-[160px] bg-white rounded-xl shadow-md p-4 flex flex-col sm:flex-row justify-between items-start sm:items-center hover:shadow-lg transition-all"
            >
              {/* Avatar + Info */}
              <div className="flex items-start sm:items-center gap-4 w-full sm:w-3/4">
                <img
                  src={`https://ui-avatars.com/api/?name=${u.username}&background=random`}
                  alt={u.username}
                  className="w-14 h-14 rounded-full object-cover"
                />
                <div className="flex-1">
                  <h2 className="text-lg font-semibold text-indigo-800">{u.username}</h2>
                  <p className="text-sm text-gray-600">
                    Speaks: <span className="font-medium">{u.currentLanguage}</span>
                  </p>
                  <p className="text-sm text-gray-600">
                    Learning: <span className="font-medium">{u.targetLanguage}</span> • Level:{" "}
                    <span className="bg-indigo-100 text-indigo-700 px-2 py-0.5 rounded text-xs">
                      {u.level}
                    </span>
                  </p>
                  <p className="text-sm italic text-gray-500 mt-1 line-clamp-2 overflow-hidden">
                    "{u.bio}"
                  </p>
                </div>
              </div>

              {/* Action Button */}
              <div className="sm:ml-auto mt-4 sm:mt-0">
                <button
                  onClick={handleLoginRedirect}
                  className="bg-green-600 text-white px-4 py-2 rounded text-sm hover:bg-green-500"
                >
                  🤝 Send Match Request
                </button>
              </div>
            </div>
          ))}
        </div>
        {/* Login button at the end */}
        <div className="text-center mt-6">
          <button
            onClick={handleLoginRedirect}
            className="bg-blue-600 text-white px-6 py-2 rounded font-semibold hover:bg-blue-500"
          >
            Login to see more
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserPreview;